import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AffordabilityParamsDTO } from './affordability-settings.model';
import { CohortDO } from '../../../../../common/domain-model-dtos';
import { AdminContextService } from '../../../../../common/services/admin.context.service';

@Injectable({
  providedIn: 'root',
})
export class AffordabilitySettingsService {
  private currentCohort: CohortDO;

  constructor(
    private adminContextService: AdminContextService,
    private http: HttpClient
  ) {
    this.adminContextService.getCohortWatcher().subscribe((cohort) => {
      this.currentCohort = cohort;
    });
  }

  public get(): Observable<AffordabilityParamsDTO> {
    return this.http.get<AffordabilityParamsDTO>(`/player-activity/api/affordability/params`, {
      params: { currency: this.currentCohort.currency.code },
    });
  }
}
